export const HOUR_MS = 3_600_000;
export const MODEL_VERSION = "2";
export type DoseStatus = "confirmed" | "pending" | "skipped";

export function positive(value: number, label = "Value"): number {
  if (!Number.isFinite(value) || value <= 0)
    throw new Error(`${label} must be a positive finite number`);
  return value;
}
export function validDate(value: Date, label = "Date"): Date {
  if (!(value instanceof Date) || !Number.isFinite(value.getTime()))
    throw new Error(`${label} is invalid`);
  return value;
}
/** Supported computational range, not a clinical dosing limit. */
export function validCadence(value: number): number {
  positive(value, "Cadence");
  if (value < 1 || value > 8760)
    throw new Error("Cadence must be between 1 hour and 365 days");
  return value;
}
export function validStatus(value: string): DoseStatus {
  if (value !== "confirmed" && value !== "pending" && value !== "skipped")
    throw new Error("Invalid dose status");
  return value;
}
